"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementPage = void 0;
var Settlement_1 = require("./Settlement");
Object.defineProperty(exports, "SettlementPage", { enumerable: true, get: function () { return Settlement_1.SettlementPage; } });
